<div class="card get-quote-container zero-margin">
    <div class="col-lg-12 outerbox-padding">
        <div class="col-md-12 " style="text-align: center;"   [innerHTML]="maintenancePageInfo">

        </div>   
    </div>
</div>

<!-- class="col-md-4 offset-md-4" -->